import {
  useI18n,
} from "@/composables/useI18n";

import {
  computed,
  ref,
} from "vue";

import type {
  Pagination,
} from "@/scripts/Common/paginationType";

import {
  Sorting,
} from "@/scripts/Common";

interface DataTableOptions {
  pagination: Pagination,
  sorting: Sorting,
  loading: boolean,
}

const useDataTableDefaults = () => {
  const {
    t,
  } = useI18n()

  const loading = ref<boolean>(false);

  const pagination = ref<Pagination>({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    totalItemCount: 0
  });

  const sorting = ref<Sorting>({
    sortBy: undefined,
    sortDesc: undefined
  });

  const dataTableOptions = ref<DataTableOptions>({
    pagination: pagination.value,
    sorting: sorting.value,
    loading: loading.value
  });

  const resetPagination = () => {
    pagination.value.pageCount = 0;
    pagination.value.page = 1;
    pagination.value.itemsPerPage = 10;
    pagination.value.totalItemCount = 0;
  }

  const currentItems = computed(() => {
    const currentItems = 1 + (pagination.value.page - 1) * pagination.value.itemsPerPage;
    const calculatedMaxItems = pagination.value.page * pagination.value.itemsPerPage;

    const currentMaxItems = calculatedMaxItems > pagination.value.totalItemCount
      ? pagination.value.totalItemCount
      : calculatedMaxItems;

    return `${currentItems}-${currentMaxItems}`;
  })

  const dataTableFooter = computed(() => (
    {
      'items-per-page-options': [10, 25, 50, 75, 100],
      'items-per-page-text': t('items_per_page_text'),
      'page-text': `${currentItems.value} / ${pagination.value.totalItemCount}`
    }
  ))

  return {
    pagination,
    sorting,
    loading,
    dataTableOptions,
    resetPagination,
    dataTableFooter
  }
}

export {
  useDataTableDefaults
}

export type {
  DataTableOptions
}
